import BaseAPI from './base/base-api';

class MisaOrderAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'misaorder';
}

export default new MisaOrderAPI();